__turbopack_context__.v({
  "ctaContainer": "UpgradePopup-module__FBIGna__ctaContainer",
  "description": "UpgradePopup-module__FBIGna__description",
  "desktopContainer": "UpgradePopup-module__FBIGna__desktopContainer",
  "diamondIcon": "UpgradePopup-module__FBIGna__diamondIcon",
  "goPremium": "UpgradePopup-module__FBIGna__goPremium",
  "image": "UpgradePopup-module__FBIGna__image",
  "lowerSection": "UpgradePopup-module__FBIGna__lowerSection",
  "maybeLater": "UpgradePopup-module__FBIGna__maybeLater",
  "mobileContainer": "UpgradePopup-module__FBIGna__mobileContainer",
  "popupMessage": "UpgradePopup-module__FBIGna__popupMessage",
  "separator": "UpgradePopup-module__FBIGna__separator",
  "textContainer": "UpgradePopup-module__FBIGna__textContainer",
  "title": "UpgradePopup-module__FBIGna__title",
});
